import NewNoteUI from "../UI/NewNoteUI";
import { motion } from "framer-motion";
const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
}
const NewNotePage = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
    >
      <NewNoteUI />
    </motion.div>
  );
};
export default NewNotePage;
